export default {
  dividerStyles: {
    width: "100%",
  },
};
